import script from "./BalancePanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalancePanel.vue?vue&type=script&setup=true&lang=ts"

import "./BalancePanel.vue?vue&type=style&index=0&id=5c9499e6&lang=scss"

const __exports__ = script;

export default __exports__